import { createAction, props } from '@ngrx/store';

import { createFailure, createSuccess } from '../utils/action-utils';

// Get Countries Actions //
const getCountriesKey = '[References] Get Countries';
export const getCountries = createAction(getCountriesKey);
export const getCountriesSuccess = createAction(
  createSuccess(getCountriesKey),
  props<{ countries: string[] }>(),
);
export const getCountriesFailure = createAction(
  createFailure(getCountriesKey),
  props<{ error: any }>(),
);

// Get Industries Actions //
const getIndustriesKey = '[References] Get Idustries';
export const getIndustries = createAction(getIndustriesKey);
export const getIndustriesSuccess = createAction(
  createSuccess(getIndustriesKey),
  props<{ industries: string[] }>(),
);
export const getIndustriesFailure = createAction(
  createFailure(getIndustriesKey),
  props<{ error: any }>(),
);
